import React, { useState, useEffect } from 'react'
import { Col, Panel, Row, Modal, Button, Icon, Message } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import { startLoading, doneLoading } from '../../../utils/loading'
import SaveButton from '../../../components/buttons/saveButton/SaveButton'
import CancelButton from '../../../components/buttons/cancelButton/CancelButton'
import ConfirmWidget from '../../confirm/ConfirmWidget'
import notification from '../../../utils/notification'
import globalMsgUtil from '../../../utils/globalMsgUtil'
import InputEvaluatesForm from '../InputEvaluatesForm'
import {
  getProjectEvaluation,
  saveProjectEvaluation,
} from '../../../redux/actions/projectEvaluation'
import EditButton from '../../../components/buttons/editButton/EditButton'

export default function CoworkerEvaluateYourselfWidget(props) {
  const { disabled } = props
  const { register, handleSubmit, errors, control, getValues, setValue, setError, clearErrors } =
    useForm()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [formSchema, setFormSchema] = useState()
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const [isEdit, setIsEdit] = useState(false)
  const [requestBody, setRequestBody] = useState()
  const projectId = sessionStorage.getItem('projectId')
  let projectProgressId = sessionStorage.getItem('param')?.substring(1)
  // console.log('progressId======>', progressId)
  // console.log('evaluations==>', formSchema)

  useEffect(() => {
    handleGetEvaluationSchema(projectId, projectProgressId)
  }, [])

  const handleGetEvaluationSchema = async (projectId, projectProgressId, evaluationId) => {
    try {
      const response = await getProjectEvaluation(projectId, projectProgressId, evaluationId)

      setFormSchema(response.forms)
      if (disabled) {
        setIsEdit(false)
      } else {
        response.forms.evaluationId ? setIsEdit(false) : setIsEdit(true)
      }

      // console.log('response==>', response)
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        setError({
          statusCode: e.response.data.status,
          errorMessage: e.response.data.errors?.message,
        })
      } else {
        setError({})
      }
    }
  }

  const handleCallService = async () => {
    startLoading()
    setIsLoading(true)
    setIsError(false)

    try {
      const response = await saveProjectEvaluation(projectId, projectProgressId, requestBody)

      if (response) {
        // sessionSetItemStr('subIncomeId', response.model.id)
        notification.open('success', {
          title: globalMsgUtil.SAVE_SUCCESS,
        })
        setIsShowConfirm(false)
        setIsEdit(false)

        // setTimeout(() => {
        //   location.reload()
        // }, 1000)
      } else {
        setIsError(true)
      }
    } catch (e) {
      console.log('error', e)
      if (e?.response?.data) {
        console.log(e?.response?.data)
        setIsError(e.response.data.errorMessage || globalMsgUtil.SET_IS_ERROR)
      } else {
        setIsError(globalMsgUtil.SET_IS_ERROR)
      }
    }

    setIsLoading(false)
    doneLoading()
  }

  const onSubmit = (data) => {
    console.log('on submit ', data)

    let newArr = []
    for (const key in data) {
      console.log(`${key}: ${data[key]}`)
      let newRes = {
        id: key,
        result: Array.isArray(data[key]) ? data[key].toString() : data[key],
        otherResult: '',
      }

      newArr.push(newRes)
    }

    const requestBody = {
      evaluationId: '',
      comment: '',
      results: newArr,
    }

    // console.log('requestBody => ', requestBody)
    setRequestBody(requestBody)
    setIsShowConfirm(true)
    // console.log('data', data)
  }

  return (
    <>
      {formSchema?.evaluationRounds?.length > 0 &&
        formSchema?.evaluationRounds?.map((rounds) => {
          // console.log('rounds', rounds)
          return (
            <Panel
              header={rounds.header}
              key={rounds.period}
              shaded
              bordered
              collapsible
              defaultExpanded
              style={{ marginBottom: '1em' }}
            >
              {rounds?.evaluations?.length > 0 &&
                rounds?.evaluations?.map((evaluations) => {
                  // console.log('evaluations', evaluations)
                  return (
                    <Panel
                      header={evaluations.name}
                      key={evaluations.code}
                      style={{ marginTop: -30 }}
                    >
                      {evaluations?.questions?.length > 0 && (
                        <InputEvaluatesForm
                          // mode={isEdit ? '' : 'VIEW'}
                          schema={evaluations?.questions}
                          register={register}
                          Controller={Controller}
                          control={control}
                          errors={errors}
                          getValues={getValues}
                          setValue={setValue}
                          clearErrors={clearErrors}
                          setIsEdit={setIsEdit}
                          disabled={!isEdit}
                        />
                      )}
                    </Panel>
                  )
                })}
              <hr />
              {!disabled &&
                (isEdit ? (
                  <Row style={{ marginTop: 20 }}>
                    <Col lg={24} md={24} sm={24} xs={24}>
                      <SaveButton
                        onClick={handleSubmit(onSubmit)}
                        style={{ marginTop: 0, marginLeft: 0 }}
                      >
                        {'บันทึกผล'}
                      </SaveButton>
                      <CancelButton
                        style={{ marginTop: 0, marginLeft: 20 }}
                        onClick={() => {
                          setIsEdit(false)
                        }}
                      >
                        {'ยกเลิก'}
                      </CancelButton>
                    </Col>
                  </Row>
                ) : (
                  <Row style={{ marginTop: 20 }}>
                    <Col lg={24} md={24} sm={24} xs={24}>
                      <EditButton
                        onClick={() => {
                          setIsEdit(true)
                        }}
                        style={{ marginTop: 0, marginLeft: 0 }}
                      >
                        {'แก้ไขการประเมิน'}
                      </EditButton>
                    </Col>
                  </Row>
                ))}
            </Panel>
          )
        })}

      <ConfirmWidget
        title={globalMsgUtil.CONFIRM_SAVE_TITLE}
        show={isShowConfirm}
        detail={globalMsgUtil.CONFIRM_SAVE_DETAIL}
        onCancle={() => setIsShowConfirm(false)}
        onConfirm={handleCallService}
      />
    </>
  )
}
